import ax from 'axios';

import {ConfigConstant} from '../constants/config';
import StorageUtils from '../utils/storage';

const getAxios = ({baseApiUrl, platformUrl}) => {
  const axios = ax.create({
    baseURL: baseApiUrl,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 50000,
  });

  axios.interceptors.request.use(
    (config) => {
      const user = StorageUtils.getUser();
      if (user && user.token) {
        config.headers['user-token'] = btoa(user.token);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error.response);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.group('network error');
      console.groupEnd();
      if (error?.response?.data?.data?.error?.code === 1012) {
        StorageUtils.removeAllStorage();
        return (window.location.href = platformUrl);
      }
      return Promise.reject(error.response || error);
    }
  );

  return axios;
};

export const httpRequest = getAxios({
  baseApiUrl: `${ConfigConstant.BASE_API_URL}`,
  platformUrl: ConfigConstant.PLATFORM_URL,
});
